/**
 * Тюнинг навигационного ядра под пешехода «последней мили» (не авто!).
 * Математика портирована из GreenGlobe (src/services/navigation), пороги
 * пересмотрены под масштаб площадки: сотни метров, скорость ~5 км/ч.
 */

/** Process noise Кальмана — донорское значение; R не константа, а адаптивный
 * (= accuracy² текущего fix'а) — чем хуже точность, тем меньше доверия измерению. */
export const KALMAN_Q = 0.001

/** Fix хуже 50 м отбрасываем: на площадке шириной в сотни метров он бесполезен
 * и только дёргает матчинг (донорское значение — подходит и пешеходу). */
export const MIN_ACCURACY_M = 50

/** Окно скользящего среднего скорости (донорское); при fix ~1 Гц это ≈10 с. */
export const SPEED_SMOOTHING_WINDOW = 10

/** Пешеход у стен ловит GPS-шум 10–20 м; 25 м отделяет реальный уход с маршрута
 * от шума (у авто в доноре было 50 м — для тропы шириной 2 м это слишком грубо). */
export const OFF_ROUTE_THRESHOLD_M = 25

/** Уход должен быть устойчивым, а не единичным выбросом: за 10 с пешеход
 * проходит ~14 м — случайный скачок GPS столько не живёт. */
export const OFF_ROUTE_DURATION_MS = 10_000

/** Дистанция предупреждения о повороте для UI: 40 м при 1.4 м/с ≈ полминуты —
 * комфортный запас пешеходу (у авто было 200 м — на площадке это весь маршрут). */
export const TURN_WARNING_DISTANCE_M = 40

/** Изменение курса больше 30° — поворот, меньше — «прямо» (донорское значение,
 * согласовано с денсификацией ≤10 м: изгибы дорожек не шумят как повороты). */
export const TURN_ANGLE_THRESHOLD_DEG = 30

/** Радиус прибытия: городская точность GPS у входа + размер крыльца.
 * Меньше — риск не сработать вовсе, больше — «прибыл» за полсотни метров до двери. */
export const ARRIVAL_RADIUS_M = 15

/** Окно матчинга по вершинам (шаг вершин ≤10 м): 5 назад ≈ 50 м, 15 вперёд ≈ 150 м.
 * Вперёд шире — пешеход движется к цели; назад узко, но хватает на откат по шуму.
 * Промах окна лечится fallback'ом на полный скан (см. map-matcher). */
export const SEARCH_WINDOW_BEHIND = 5
export const SEARCH_WINDOW_AHEAD = 15

/** watchPosition: кэшированная позиция не старше 1 с — за секунду пешеход
 * проходит < 2 м, свежее не нужно, а батарею бережёт. */
export const GEO_MAXIMUM_AGE_MS = 1000

/** watchPosition: 10 с на fix — дольше значит GPS недоступен, ждать смысла нет. */
export const GEO_TIMEOUT_MS = 10_000

/** Нет fix'ов дольше этого — GPS считается потерянным: честный индикатор
 * «позиция неизвестна» + степпер (fix'и возобновились — вернётся сам). */
export const GPS_STALE_MS = 12_000

/** Период проверки залипания GPS. */
export const GPS_WATCHDOG_INTERVAL_MS = 3_000

/** Минимальный сдвиг для вычисления курса по двум позициям:
 * ниже метра азимут — чистый шум координат. */
export const HEADING_MIN_MOVE_M = 1

/** Частота симулятора = типичная частота выдачи watchPosition. */
export const MOCK_UPDATE_INTERVAL_MS = 1000

/** Скорость симулятора по умолчанию — обычный пешеходный темп. */
export const MOCK_DEFAULT_SPEED_KMH = 5

/** Имитируемая точность fix'а — типичная городская точность GPS. */
export const MOCK_ACCURACY_M = 10

/** Амплитуда шума координат симулятора ≈ ±0.5 м (разброс ~1 м, донорская). */
export const MOCK_JITTER_DEG = 0.00001
